import type { FaireProductEntity } from "../../entity_types/product";

export const p_q6gyx9h439: FaireProductEntity = {
  token: "p_q6gyx9h439",
  type: "product",
  name: "Watermelon Lime",
  brandToken: "b_2ncsmapy03",
  brandName: "Olipop",
  imageUrl:
    "https://cdn.faire.com/fastly/6fb9d9d73a6c6bd543740e997b89b8b721464f588fc46bae0000b0e6457dd17b.png",
  galleryImageUrls: [],
  priceDollars: 28.99,
  description:
    "That candy-like flavor you’ve always loved, but in liquid form. With a mix of watermelon, tart cherry, and lime juice, this bubbly soda balances brightness with a crave-worthy pop of sweetness.\n\nWholesale cost offers landed cost of $2.42 per unit, which provides a 40% gross margin to the retailer at $3.99 MSRP.\n\n",
  tags: [],
  msrpDollars: 57.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T17:24:12.732Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
